<template>
  <div>
    <div v-if="this.loaded" class="">
      <div class="d-inline-block mr-2" v-for="preference in preferences" :key="preference.id">
        <input
          type="checkbox"
          :id="'preference_' + preference.id"
          class="d-none"
          v-model="userPreferences"
          :value="preference.id"
          @change="change($event, preference)"
        >
        <label
          :for="'preference_' + preference.id"
          :title="preference.name"
        >
          <div
            class="button btn-block text--small py-1 px-3 mt-2"
            :class="{
              'button__fill': userPreferences.includes(preference.id),
              'button__outline--gray': !userPreferences.includes(preference.id)
            }"
          >
            <span
              :class="{ 'opacity-0': !userPreferences.includes(preference.id) }"
              class=""
            >&#10003;</span>
            {{ preference.name }}
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import PreferencesChooseMixin from '../../../front/components/User/PreferencesChooseMixin';

export default {
  name: 'PreferencesEditComponent',
  components: {},
  mixins: [PreferencesChooseMixin],
  props: {
    value: { type: Array },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {
    userPreferences: {
      handler(newVal) {
        this.$emit('input', newVal);
        if (this.loaded) {
          this.updateDataDebounced();
        }
      },
      deep: true,
    },
    value: {
      handler(newVal) {
        this.userPreferences = newVal;
      },
      // deep: true,
    },
  },
  methods: {
    updateDataDebounced: _.debounce(function () {
      this.updateData();
    }, 1000),
    updateData: function () {
      axios
        .post(zRoute('ajax.user.preferences.update'), { preferences: this.userPreferences });
    },
  },
  mounted() {
    this.userPreferences = this.value;
  },
};
</script>

<style scoped>
.button__fill {
  border: 1px solid transparent;
  box-shadow: 0 2px 3px 1px rgba(0, 0, 0, 0.1411764706);
}
</style>
